import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, IStorage, LicenseService, LocalStorage, User } from '@isophi/core-legacy';
import { IconService } from '@isophi/core-ui';
import { TranslocoService } from '@jsverse/transloco';

import { environment } from '../../../../../../src/environments/environment';
import { ApiConfigurationService } from '../../../../../app/api/api-configuration.service';
import { RouterLinkFactory } from '../../../../core/router/router-link.factory';
import { HelperService } from '../../../../core/services/helper.service';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-logged-user',
  templateUrl: './logged-user.component.html',
  styleUrls: ['./logged-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoggedUserComponent {
  protected readonly helperService = inject(HelperService);
  isProduction = environment.production;

  private storage: IStorage;

  constructor(
    protected icons: IconService,
    public links: RouterLinkFactory,
    private router: Router,
    private apiConfigurationService: ApiConfigurationService,
    private authService: AuthService,
    private licenseService: LicenseService,
    private translocoService: TranslocoService,
    private userService: UserService
  ) {
    this.storage = new LocalStorage();
  }

  get authenticatedUser(): User {
    return this.authService.loggedUser;
  }

  get authenticatedUserEmail(): string {
    return this.authenticatedUser?.email;
  }

  get authenticatedUserFullName(): string {
    return this.authenticatedUser?.fullName || this.authenticatedUser?.email;
  }

  get authenticatedUserRole(): string {
    if (this.authenticatedUser?.teacher?.isDirector()) {
      return this.translocoService.translate('user/director');
    }
    if (this.authenticatedUser?.teacher?.isManager()) {
      return this.translocoService.translate('user/manager');
    }
    return this.translocoService.translate('user/teacher');
  }

  logout(): void {
    this.apiConfigurationService.removeAuthTokenForSwagger();
    this.userService.clearSelectedKindergarten();
    this.authService.logoutUser(this.storage);
    this.storage.removeOnLogout();
    this.licenseService.clear();
    this.router.navigate(this.links.login());
  }
}
